class Supplier {
  constructor(data = {}) {
    this.id = data.id;
    this.name = data.name;
    this.address = data.address;
    this.phone = data.phone;
    this.email = data.email;
    this.status = data.status;
    this.primary_contact_name = data.primary_contact_name;
    this.primary_contact_email = data.primary_contact_email;
    this.primary_contact_phone = data.primary_contact_phone;
    // Handle products array - could be direct array or wrapped
    if (Array.isArray(data.products)) {
      this.products = {
        items: data.products
      };
    } else if (data.products && Array.isArray(data.products.items)) {
      this.products = data.products;
    } else {
      this.products = {
        items: []
      };
    }
  }

  mapData(data) {
    this.id = data.id;
    this.name = data.name;
    this.address = data.address;
    this.phone = data.phone;
    this.email = data.email;
    this.status = data.status;
    this.primary_contact_name = data.primary_contact_name;
    this.primary_contact_email = data.primary_contact_email;
    this.primary_contact_phone = data.primary_contact_phone;
    // Handle products array - could be direct array or wrapped
    if (Array.isArray(data.products)) {
      this.products = {
        items: data.products
      };
    } else if (data.products && Array.isArray(data.products.items)) {
      this.products = data.products;
    } else {
      this.products = {
        items: []
      };
    }
  }
}

export default Supplier; 